<template>
  <div class="match">
    <div class="options"></div>
    <div class="athletes">
      <div class="red table-danger">
        <div class="athlete">{{ red.athlete }}</div>
        <div class="team">{{ red.team }}</div>
      </div>
      <div class="blue table-primary">
        <div class="athlete">{{ blue.athlete }}</div>
        <div class="team">{{ blue.team }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Match',
  props: ['red', 'blue'],
};
</script>

<style scoped>
  .match {
    display: flex;
    flex-direction: row;
  }

  .athletes {
    display: flex;
    flex-direction: column;
    height: 100px;
    line-height: 20px;
    width: 200px;
    text-align: start;
  }

  .red, .blue {
    padding: 4px 5px;
    border: 1px solid gray;
  }

  .options {
    position: relative;
    width: 50px;
    line-height: 100px;
    background-color: gray;
  }
</style>
